import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { FormDatePicker, FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { GeneralInfoTabFormValues } from "@/entities/general-info-tab-content/model";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const AnniversaryField = ({ index, onBlur, onChange }: Props) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<GeneralInfoTabFormValues>();
  const anniversaryDateLength = Number(watch(`anniversaries.${index}.anniversary`)?.length);
  const isOnlyYearPicker = anniversaryDateLength ? anniversaryDateLength !== 10 : false;

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FieldLayout>
      <FormInput
        name={`anniversaries.${index}.description`}
        placeholder={t("contactsPage.generalInfo.type")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormDatePicker
        showNow={false}
        hideOnlyYearCheckbox={false}
        isOnlyYearPicker={isOnlyYearPicker}
        name={`anniversaries.${index}.anniversary`}
        placeholder={t("common.date")}
        customOnChange={handleBlur}
      />
    </FieldLayout>
  );
};
